import { render, staticRenderFns } from "./SafetyGuanjiaDialog.vue?vue&type=template&id=167c735e&scoped=true"
import script from "./SafetyGuanjiaDialog.vue?vue&type=script&lang=js"
export * from "./SafetyGuanjiaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167c735e",
  null
  
)

export default component.exports